import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import HttpService from "../services/HttpServices";
import { useSelector } from "react-redux";

const apiService = HttpService;

// Initial state of the slice
const initialState = {
  categoriesData: [], // List of businessUnits for the landing page
  categoryDetails: {}, // Details of a single businessUnit
  loading: false,
  error: null,
};

// Async thunk for fetching business unit for the landing page
export const fetchCategories = createAsyncThunk(
  "categories/fetchCategories",
  async (thunkAPI) => {
    try {
      const response = await apiService.get(`/admin/categories/`);
      return response.data;
    } catch (error) {
      console.log("error : ", error);

      return thunkAPI.rejectWithValue(error.response.data || error.message);
    }
  }
);

// Async thunk for creating a Business Unit
export const createCatagory = createAsyncThunk(
  "categories/createCatagory",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await apiService.post("/admin/categories", formData, {
        headers: {
          "Content-Type": "multipart/form-data", // Set this to indicate form data
        },
      });
      return response.data; // response
    } catch (error) {
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

export const deleteCategoryById = createAsyncThunk(
  "categories/deleteCategoryById",
  async ({ categoryId }, { rejectWithValue }) => {
    try {
      const response = await apiService.delete(
        `/admin/categories/${categoryId}`
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

// Async thunk for fetching an businessunit by ID
export const fetchCategoryById = createAsyncThunk(
  "categories/fetchCategoryById",
  async (categoryId, { rejectWithValue }) => {
    try {
      const response = await apiService.get(`/admin/categories/${categoryId}`);
      return response.data.data; // response
    } catch (error) {
      console.error("Failed to fetch Business Unit details:", error.message);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

// update business unit details
export const updateCategoryById = createAsyncThunk(
  "categories/updateCategoryById",
  async ({ categoryId, updatedFormData }, { rejectWithValue }) => {
    try {
      // Make the API request to update the category
      const response = await apiService.put(
        `/admin/categories/${categoryId}`,
        updatedFormData,
        {
          headers: {
            "Content-Type": "multipart/form-data", // Set this to indicate form data
          },
        }
      ); // PUT request to update the category

      return response.data; // Return the updated category data
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


// fetch Company Name
export const fetchCompanyName = createAsyncThunk(
  "categories/fetchCompanyName",
  async (queryParams, thunkAPI) => {
    try {
      const response = await apiService.get("/business-units", {
        params: queryParams,
      });
      return response.data;
    } catch (error) {
      console.log("error : ", error);

      return thunkAPI.rejectWithValue(error.response.data || error.message);
    }
  }
);

// The business unit slice
export const categorySlice = createSlice({
  name: "categories",
  initialState,
  reducers: {
    resetBusinessUnitState: (state) => {
      state.categoriesData = [];
      state.paginationInfo = {};
      state.categoryDetails = {};
      state.loading = false;
      state.error = null;
      state.companyName = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // Handling fetch business units
      .addCase(fetchCategories.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.categoriesData = action.payload.data.listData; // This is your response.data.data
        state.paginationInfo = {
          totalRecords: action.payload.data.count,
        };
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Handling create Business Unit
      .addCase(createCatagory.pending, (state) => {
        state.loading = true;
      })
      .addCase(createCatagory.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createCatagory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Handling fetch BusinessUnit By Id
      .addCase(fetchCategoryById.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCategoryById.fulfilled, (state, action) => {
        state.loading = false;
        state.categoryDetails = action.payload;
      })
      .addCase(fetchCategoryById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // // Delete Business Unit by ID
      // .addCase(deleteBusinessUnitById.pending, (state) => {
      //   state.loading = true;
      //   state.error = null;
      // })
      // .addCase(deleteBusinessUnitById.fulfilled, (state) => {
      //   state.loading = false;
      //   state.error = null;
      // })
      // .addCase(deleteBusinessUnitById.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error = action.payload;
      // })
      // Delete category by ID
      .addCase(deleteCategoryById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCategoryById.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(deleteCategoryById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchCompanyName.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCompanyName.fulfilled, (state, action) => {
        state.loading = false;
        state.companyName = action.payload.data; // This is your response.data.data
      })
      .addCase(fetchCompanyName.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateCategoryById.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateCategoryById.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateCategoryById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Export actions and reducer
export const { resetBusinessUnitState } = categorySlice.actions;
export default categorySlice.reducer;
